import React, { useMemo } from 'react';
import { IoClose } from 'react-icons/io5';

const formatDate = (value) => {
    if (!value) return "";
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return String(value);
    return d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
};

const ActiveFilters = ({ filters = {}, initialFilters = {}, filterItems = {}, onFilterChange, resetFilter }) => {
    const chips = useMemo(() => {
        const list = [];
        const seen = [];

        (filterItems?.dropdown || []).forEach((group) => {
            const value = filters?.[group.key];
            const initial = initialFilters?.[group.key];
            if (value !== undefined && value !== initial) {
                const optionName = group.options?.find(o => String(o.key) === String(value))?.name ?? String(value);
                list.push({ key: group.key, label: `${group.name}: ${optionName}`, reset: () => onFilterChange?.(group.key, initial) });
                seen.push(group.key);
            }
        });

        (filterItems?.datepicker || []).forEach((picker) => {
            const value = filters?.[picker.key];
            const initial = initialFilters?.[picker.key];
            if (value && value !== initial) {
                list.push({ key: picker.key, label: `${picker.name}: ${formatDate(value)}`, reset: () => onFilterChange?.(picker.key, initial) });
                seen.push(picker.key);
            }
        });

        (filterItems?.daterangepicker || []).forEach((range) => {
            const from = filters?.[range.from.key];
            const to = filters?.[range.to.key];
            if (from || to) {
                list.push({
                    key: range.key,
                    label: `${range.name}: ${from ? formatDate(from) : '…'} – ${to ? formatDate(to) : '…'}`,
                    reset: () => { onFilterChange?.(range.from.key, initialFilters?.[range.from.key]); onFilterChange?.(range.to.key, initialFilters?.[range.to.key]); }
                });
                seen.push(range.from.key);
                seen.push(range.to.key);
            }
        });

        if (Array.isArray(filterItems?.sort) && filters?.sortBy && (filters.sortBy !== initialFilters?.sortBy || filters.sort !== initialFilters?.sort)) {
            const sortName = filterItems.sort.find(s => s.key === filters.sortBy)?.name || filters.sortBy;
            list.push({
                key: '__sort',
                label: `Sort: ${sortName} ${filters.sort === false ? '↓' : '↑'}`,
                reset: () => { onFilterChange?.('sortBy', initialFilters?.sortBy); onFilterChange?.('sort', initialFilters?.sort); }
            });
        }

        return list;
    }, [filters, initialFilters, filterItems, onFilterChange]);

    if (!chips.length) return null;

    return (
        <div className="active-filters">
            {chips.map((chip) => (
                <span className="active-filter-chip" key={chip.key}>
                    {chip.label}
                    <button type="button" aria-label={`Remove filter: ${chip.label}`} onClick={chip.reset}>
                        <IoClose />
                    </button>
                </span>
            ))}
            <button type="button" className="active-filters-clear" onClick={resetFilter}>
                Clear all
            </button>
        </div>
    );
};

export default ActiveFilters;
